import React, { useContext, useEffect, useRef, useState } from 'react';
import ReferImg from '../../assets/refer.svg'
import referBg from '../../assets/refer_bg.jpg'
import { getAllLiveWorkshops, getAllVisibleBanners, getContinueWatching, getRecentSessions, getUpcomingSvByBrokerId } from '../../services/public/public.service';
import { ReactComponent as RightIcon } from '../../assets/icons/righticon_primary.svg'
import { Link, useHistory } from 'react-router-dom';
import Slider from "react-slick";
import Consumer from '../../helpers/context'
import PaymentPlanModal from '../Settings/Modal/PaymentPlanModal';
import DashboardCard from './DashboardCard';
import { ReactComponent as BackIcon } from '../../assets/icons/leftArrow.svg';
import { ReactComponent as LeftSlideIcon } from '../../assets/icons/Left_slider.svg';
import { ReactComponent as RightSlideIcon } from '../../assets/icons/Right.svg'
import { ReactComponent as HomeWhiteIcon } from '../../assets/icons/homeWhite.svg';
import { ReactComponent as BuildingIcon } from '../../assets/icons/golden_building.svg';
import { ReactComponent as PossessionIcon } from '../../assets/icons/golden_calendar.svg';
import { ReactComponent as RupeesIcon } from '../../assets/icons/rupees_icon.svg';
import { ReactComponent as ConfigIcon } from '../../assets/icons/Category.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/location.svg';
import { ReactComponent as WhatsappIcon } from '../../assets/plus_icon/whats_app.svg';
import { ReactComponent as CallIcon } from '../../assets/icons/call.svg';
import Banner from '../../components/Banner';
import style from '../Settings/Projects/style.module.css';
import '../Settings/Projects/style.css'
import TooltipText from '../../components/Tooltip';
import moment from 'moment';
import { getProjects } from '../../services/private/company.service';
import Offers from '../Settings/Projects/Offers';
import ScheduleSiteVisitModal from '../Plus LeadManager/Modal/ScheduleSiteVisitModal';
import SitevisitDetailsModal from '../Plus LeadManager/Modal/SitevisitDetailsModal';
import { getBrokerSiteVisit, getUsers } from '../../services/private/plus.leads.service';
import { toast } from 'react-toastify';
import Timeline from '../Plus LeadManager/Modal/Timeline';
import SitevisitReScheduleModal from '../Plus LeadManager/Modal/sitevisitReScheduleModal';

const numberFormat = (num) => {
    if (num >= 10000000) {
        return (num / 10000000).toFixed(2).replace(/\.0$/, '') + 'Cr'
    }
    if (num >= 100000) {
        return (num / 100000).toFixed(2).replace(/\.0$/, '') + 'L';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
    }
    return num
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <RightSlideIcon />

        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <LeftSlideIcon />

        </div>
    );
}

const watch_settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 1000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    // responsive: [
    //     {
    //         breakpoint: 1024,
    //         settings: {
    //             slidesToShow: 4,
    //             slidesToScroll: 4,
    //             infinite: true,
    //             dots: true
    //         }
    //     },
    //     {
    //         breakpoint: 600,
    //         settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 2
    //         }
    //     },
    //     {
    //         breakpoint: 480,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1
    //         }
    //     }
    // ]
}

const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
};

const Dashboard = () => {
    const [allWorkshops, setAllWorkshop] = useState([]);
    const [continueWatching, setContinueWatching] = useState([]);
    const [recentSessions, setRecentSessions] = useState([]);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [sitevisits, setSitevisits] = useState([]);
    const [projects, setProjects] = useState([]);
    const [showSiteVisitModal, setShowSitevisitModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState('');
    const [projectIndex, setProjectIndex] = useState(0);
    const [selectedLead, setSelectedLead] = useState({});
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showReScheduleModal, setShowReScheduleModal] = useState(false);
    const [showTimeline, setShowTimeline] = useState(false);
    const [selectedTmelineLead, setSelectedTimelineLead] = useState({});
    const [users, setUsers] = useState([]);
    console.log("site visits", sitevisits)

    const { userProfile, isSubscribed, borkerDetails } = useContext(Consumer);

    const slickRef = useRef()

    const history = useHistory();

    const getDashboardData = async () => {
        const res = await getRecentSessions()
        if (res.data.status === 200) {
            setRecentSessions(res.data.data.slice(0, 5));
        }
    }

    const getCompanyUsers = async () => {
        const res = await getUsers();
        if (res.data.status === 200) {
            const mappedUsers = res.data.data.users.filter(i => !i.is_owner).map(i => ({ ...i, label: i.name, value: i.id }))
            setUsers(mappedUsers);
        }
    }

    const handleGetSVDetails = async (lead) => {
        try {
            const res = await getBrokerSiteVisit(lead?.uuid);
            if (res.data.status === 200) {
                setSelectedLead(res.data.data);
                setShowDetailModal(true)
            }
        } catch (err) {
            console.log({ err })
        }
    }

    const getWorkshop = async () => {
        await getAllLiveWorkshops()
            .then((res) => {
                setAllWorkshop(res.data.slice(0, 4))
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const getSVData = async () => {
        const res = await getUpcomingSvByBrokerId();
        if (res.data.status === 200) {
            setSitevisits(res.data.data.splice(0, 3))
        }
    }

    const getAllProjects = async () => {

        await getProjects({}, '').then((res) => {
            if (res.status === 200) {
                console.log(res.data.data, 'data')
                setProjects(res.data.data.splice(0, 4));
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }


    const getContinueWatchingList = async () => {
        const res = await getContinueWatching()
        if (res.data.status === 200) {
            setContinueWatching(res.data.data);
        }
    }
    useEffect(() => {
        getDashboardData();
        getContinueWatchingList();
        getSVData();
        getAllProjects();
        getCompanyUsers();
        // getWorkshop();
        // slickRef.innerSlider.onWindowResized()
    }, []);

    const styles = {
        backgroundImage: `url(${referBg})`,
        // backgroundSize: 'cover',        
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `-422px -159px`
    };

    return (
        <div className='w-full !p-4  h-full overflow-auto' >
            <div className={`!h-[400px] !mb-10 banner-slider`} id='home'>
                <Banner />
            </div>
            {continueWatching?.length > 0 && <div className='!mt-4 relative'>
                <div className='flex justify-between items-center'>
                    <div className='flex item-center !mb-4'>
                        <h3 className='text-lg font-semibold mb-0 mr-2'>
                            Countinue Watching
                        </h3>
                        <Link className='text-primary flex items-center fill-primary' to='/learning-center'>
                            Show More
                            <span className='fill-primary'>
                                <RightIcon className='fill-primary' />
                            </span>
                        </Link>
                    </div>
                </div>
                <div className='w-full slider-container' >
                    <Slider
                        // ref={setSliderRef}
                        {...watch_settings}>
                        {
                            continueWatching.map((workshop, index) => (
                                <div key={`${workshop.id}_${index}`} className='!px-4'>
                                    <DashboardCard
                                        workshop={workshop}
                                        isSubscriptionExpire={!isSubscribed}
                                        setShowPaymentModal={setShowPaymentModal}
                                        borkerDetails={borkerDetails}
                                        showPlayIcon={true}
                                    />
                                </div>
                            ))}
                    </Slider>
                </div>
            </div>}
            {(userProfile?.is_owner || userProfile?.role?.allowed_permissions?.includes('learning_center_access')) && <div className='!mt-4'>
                <div className='flex items-center !mb-4'>
                    <h3 className='text-lg font-semibold mr-2 mb-0'>
                        Learning Center
                    </h3>
                    <Link className='text-primary flex items-center fill-primary' to='/learning-center?tab=courses'>
                        Show all
                        <span className='fill-primary'>
                            <RightIcon className='fill-primary' />
                        </span>
                    </Link>
                </div>
                <div className='flex item-center !gap-4'>

                    {/* <Slider setting={{
                        dots: true,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }}> */}
                    {

                        recentSessions.map((workshop) => {
                            return <div key={workshop.id} className='w-[250px]'>
                                <DashboardCard
                                    workshop={workshop}
                                    isSubscriptionExpire={!isSubscribed}
                                    setShowPaymentModal={setShowPaymentModal}
                                    borkerDetails={borkerDetails}
                                    showPlayIcon={false}
                                />
                            </div>
                        })
                    }
                    {/* </Slider> */}
                </div>
            </div>}

            {projects?.length > 0 && <div className='!mt-4'>
                <div className='flex items-center !mb-4'>
                    <h3 className='text-lg font-semibold mr-2 mb-0'>
                        Project
                    </h3>
                    <Link className='text-primary flex items-center fill-primary' to='/projects'>
                        Show all
                        <span className='fill-primary'>
                            <RightIcon className='fill-primary' />
                        </span>
                    </Link>
                </div>
                <div className='flex item-center !gap-4'>

                    {/* <Slider setting={{
                        dots: true,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }}> */}
                    {projects?.map((project, index) => {
                        const { uuid, name } = project
                        return (
                            // <Link to={`/projects/details/${uuid}`} className='' >
                            <div className={`${style.girdProjectCard} shadow-boxshadow !w-[343px] !p-0 !rounded-xl hover:!bg-white`}
                                key={uuid}
                            >
                                <figure className='position-relative mb-16 !rounded-xl overflow-hidden'>
                                    <div className='bg-gradient-to-r from-[#2064FA] to-[#3B37F5] w-max absolute text-white text-[10px] font-semibold top-2.5 left-2.5 !py-1 !px-2 rounded-lg'>Exclusive Launch</div>

                                    {project?.media?.length && <img src={project?.media[0]?.url} alt="" className='w-100' />}
                                    {!project?.media?.length &&
                                        <div className={`${style.cardthumbnail} d-flex align-items-center justify-content-center`}>
                                            <HomeWhiteIcon />
                                        </div>
                                    }

                                </figure>
                                <div className='!py-3'>
                                    <div className='flex justify-between px-3'>

                                        <div className='flex flex-col'>
                                            {name?.length > 30 ? <TooltipText title={name}>
                                                <h1 className='text-textblack inter text-xl font-bold mb4 lh-22 text-capitalize w-[300px] truncate'>
                                                    {name}
                                                </h1>
                                            </TooltipText> :
                                                <h1 className='text-textblack inter text-xl font-bold mb4 lh-22 text-capitalize'>
                                                    {name}
                                                </h1>
                                            }
                                            {project.site_address && <p className='m-0 text-black700 text-xs'>
                                                {project.site_address || ''}
                                            </p>}
                                        </div>
                                        <div className='h-12 w-12 rounded-lg'>
                                            <img src={project?.logo || ''} alt="" className='rounded-lg' />
                                        </div>
                                    </div>

                                    <div className='flex flex-col px-3 space-y-3 pt-3'>
                                        <div className='flex justify-between'>
                                            <div className='flex items-center w-7/12 gap-2'>
                                                <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                    <RupeesIcon />
                                                </span>
                                                <span className='text-black800 text-xs font-medium'>{project?.starting_price ? `Starts at ₹${numberFormat(+project?.starting_price)}` : '-'}</span>
                                            </div>
                                            <div className='flex items-center w-5/12  gap-2'>
                                                <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                    <BuildingIcon />
                                                </span>
                                                <span className='text-black800 text-xs font-medium'>{project?.configuration.join(', ')} </span>
                                            </div>
                                        </div>
                                        <div className='flex justify-between'>
                                            {project?.possession_date && <div className='flex items-center w-7/12 gap-2'>
                                                <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                    <PossessionIcon />
                                                </span>
                                                <span className='text-black800 text-xs font-medium'> Possession: {moment(project?.possession_date).format('MMM YYYY')}  </span>
                                            </div>}
                                            {project?.unit_configuration.length > 0 && <div className='flex items-center w-5/12	gap-2'>
                                                <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                    <ConfigIcon />
                                                </span>
                                                <TooltipText title={project.unit_configuration.join(', ')}>
                                                    <div className='truncate text-black800 text-xs font-medium w-full'> {project.unit_configuration.join(', ')} </div>
                                                </TooltipText>
                                            </div>}
                                        </div>
                                    </div>
                                    {project.offers.length > 0 &&
                                        <div className='offer-slider !w-full' >
                                            <div className='px-3 my-3 uppercase text-[10px] text-[#667085] font-medium flex items-center gap-2'>Offers <span className='w-full h-px border-b border-grayLight border-dashed inline-block'></span></div>
                                            <div className='pl-3 offerslider'>
                                                <Offers offers={project?.offers} setShowSitevisitModal={setShowSitevisitModal} setSelectedProject={setSelectedProject} project={project} />
                                            </div>

                                        </div>
                                    }
                                </div>

                                {/* <Link to={`/projects/details/${uuid}`} className={`${style.cardviewProjectbtn}`}></Link> */}

                            </div>
                        )
                    })
                    }
                    {/* </Slider> */}
                </div>
            </div>}

            {sitevisits.length > 0 && <div className='!mt-4'>
                <div className='flex items-center !mb-4'>
                    <h3 className='text-lg font-semibold mr-2 mb-0'>
                        Upcoming Site visits
                    </h3>
                    <Link className='text-primary flex items-center fill-primary' to='/leads'>
                        Show all
                        <span className='fill-primary'>
                            <RightIcon className='fill-primary' />
                        </span>
                    </Link>
                </div>
                <div className='flex items-center !gap-4 dashboard-leads'>
                    {
                        sitevisits.map((lead, index) => (
                            <div className='!w-1/3' key={`${lead.customer_name}_${index}`}>
                                <div className='!p-3.5 border rounded-[10px] lead-card-shadow w-full' >
                                    <div className='flex justify-between'>
                                        <div className=''>
                                            <h2 className='text-base font-bold text-textblack'>{lead?.customer_name}</h2>
                                            {/* <p className='m-0 text-xs text-black700'>12:10 PM, 24 June</p> */}
                                        </div>
                                        <div className='flex items-center space-x-4'>
                                            <a className='' href={`https://wa.me/${lead?.customer_mobile}`} target='_blank'>
                                                <WhatsappIcon className='w-8 h-8' />
                                            </a>

                                            <button onClick={() => {
                                                navigator.clipboard.writeText(lead.customer_mobile).then(function () {
                                                    toast.success('Mobile number Copied');
                                                }, function (err) {
                                                    toast.error('Could not copy');
                                                });
                                            }}>
                                                <TooltipText title={lead.customer_mobile}>
                                                    <CallIcon className=' stroke-black800 w-6 h-6' />
                                                </TooltipText>
                                            </button>
                                            {/* <button
                                        className='border border-primary rounded-lg text-primary text-sm font-medium py-1.5 !px-3 primary-button hover:!text-white'
                                        onClick={() => {
                                            setSelectedLead(lead);
                                            setShowSitevisitModal(true);
                                        }}
                                    >
                                        + Add Project for Visit
                                    </button>                                     */}
                                        </div>
                                    </div>
                                    <div className='!my-4'>
                                        <p className='m-0 text-black800 text-xs font-medium flex items-center'>Projects({lead?.site_visits?.length}) <span className='border-t border-dashed w-full inline-block !ml-1'></span></p>
                                    </div>
                                    <div className='!w-full site-visit-slider'>
                                        <Slider {...settings}>
                                            {lead.site_visits.map((item, pIndex) => (
                                                <div className=''>
                                                    <div className='!p-3 !w-[296px] border rounded-xl cursor-pointer sv-card !mr-4' onClick={() => {
                                                        // setSelectedLead(lead)
                                                        setProjectIndex(pIndex);
                                                        setSelectedProject(item)
                                                        // setShowDetailModal(true)
                                                        handleGetSVDetails(item)
                                                    }}>
                                                        <p className='m-0 text-black800 text-xs w-max font-semibold !py-1 px-2.5 leads-project project-name rounded-lg'>{item?.project_name}</p>
                                                        <div className='!mt-3 flex flex-row'>
                                                            <div className='flex flex-col items-center !mr-2 w-8 grow-1 shrink-1 basis-8'>
                                                                <div className='rounded-full bg-grey-light flex items-center'>
                                                                    <LocationIcon className=' fill-black800 ' />
                                                                </div>
                                                                <div className='border-l !mt-1 !h-[calc(100%-24px)]'></div>
                                                            </div>
                                                            <div className='flex w-full flex-col items-start !mt-2'>
                                                                <p className='m-0 text-black800 text-sm font-semibold leading-5'>Site Visit {!item.is_completed ? 'Scheduled' : 'Completed'} {item.type ? `(${item.type})` : ''} </p>
                                                                <p className='mb-0 text-xs text-black700 font-medium  leading-5 !mt-1'>{moment(item.schedule_date).format('hh:mm a Do MMM YYYY')}</p>
                                                                {item?.tagging_validity && <p className='mb-0 text-xs font-medium leading-5 text-[#32BA7C]'>Tagging: <span className='capitalize'>{item?.tagging_validity ? `${item?.tagging_validity} ${item?.tagging_validity_unit} left` : '-'}</span></p>}
                                                                {item?.assigned_to && <p className='mb-0 text-xs text-black700 font-medium leading-5 '>Assigned to: <span className='capitalize'>{item.assigned_to}</span></p>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            }
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>}
            {/* <div className='w-[55%] !mt-10'>
                <div className='w-full rounded-lg !mt-5 cursor-pointer' onClick={() => {
                    history.push('/settings/refer');
                }}>
                    <div className='flex justify-between !px-4 !pt-4 !pb-0 shadow-2xl rounded-lg' style={styles}>
                        <div className='mt-3 w-[300px]'>
                            <p className='m-0 text-2xl font-semibold'>Good things should be shared, right?</p>
                            <p className='m-0 text-base'>Refer the app to your friends to get 70% Off</p>
                            comment thid div
                             <div className='!mt-4'>
                                <button className='bg-textblack rounded-lg !px-3 !py-2'>
                                    Refer a friend
                                </button>
                            </div>
                        </div>
                        <div className='!mt-7 !mr-5'>
                            <div className='flex justify-end'>
                                <BackIcon className='rotate-180 h-6 w-6 !mb-4' />
                            </div>
                            <img src={ReferImg} alt="" />
                        </div>
                    </div>
                </div>
            </div> */}
            {showPaymentModal && <PaymentPlanModal show={showPaymentModal} closeModal={() => setShowPaymentModal(false)} paymentFrom={'modal'} />}
            {showSiteVisitModal && <ScheduleSiteVisitModal
                show={showSiteVisitModal}
                closeModal={() => {
                    setShowSitevisitModal(false)
                    setSelectedProject('')
                }}
                uuid={selectedProject}
                sitevisits={sitevisits}
                redirectFrom='project'
            />}

            {showDetailModal && Object.keys(selectedLead).length && <SitevisitDetailsModal
                show={showDetailModal}
                closeModal={() => setShowDetailModal(false)}
                selectedLead={selectedLead}
                // selectedLead={selectedProject}
                setShowReScheduleModal={setShowReScheduleModal}
                setShowSitevisitModal={setShowSitevisitModal}
                projectIndex={projectIndex}
                setSelectedTimelineLead={setSelectedTimelineLead}
                setShowTimeline={setShowTimeline}
            />}

            {showReScheduleModal && Object.keys(selectedLead).length &&
                <SitevisitReScheduleModal
                    show={showReScheduleModal}
                    selectedLead={selectedLead}
                    closeModal={() => {
                        setShowReScheduleModal(false)
                        setSelectedLead({})
                    }}
                    handleGetLeads={() => { }}
                    userProfile={userProfile}
                    users={users}
                />}
            {
                showTimeline && <Timeline show={showTimeline} closeModal={() => setShowTimeline(false)} uuid={selectedTmelineLead?.site_visits[0].uuid} />
            }

        </div>
    )
}

export default Dashboard